import { motion } from 'framer-motion';
import certificates from '../data/certificates.json';
import { useLanguage } from '../LanguageContext';
import './Certificates.css';

function CertBadge({ cert, t }) {
  return (
    <>
      <div className="certificate-icon">
        <img src={cert.img} alt={`${cert.issuer} badge`} />
      </div>
      <div className="certificate-title">{cert.title}</div>
      <div className="certificate-issuer">{cert.issuer}</div>
      <div className="certificate-date">
        {t.certificates.issued} {cert.date}
        {cert.expiry && ` · ${t.certificates.expires} ${cert.expiry}`}
      </div>
    </>
  );
}

function Certificates() {
  const { t } = useLanguage();

  return (
    <section className="certificates-section">
      <h2 className="certificates-title">{t.certificates.title}</h2>

      <div className="certificates-list">
        {certificates.map((cert, idx) => {
          const content = <CertBadge cert={cert} t={t} />;
          return cert.link ? (
            <motion.a
              className="certificate-card glass"
              href={cert.link}
              target="_blank"
              rel="noopener noreferrer"
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
            >
              {content}
            </motion.a>
          ) : (
            <motion.div
              className="certificate-card glass"
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
            >
              {content}
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}

export default Certificates;
